import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { TestComponent } from './test/test.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { ArtistGridComponent } from './artist-grid/artist-grid.component';
import { CompanyGridComponent } from './company-grid/company-grid.component';
import { AdvisorsComponent } from './advisors/advisors.component';
// import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';


@NgModule({
  declarations: [
    AppComponent,
    TestComponent,
    HowItWorksComponent,
    HomeComponent,
    FooterComponent,
    ArtistGridComponent,
    CompanyGridComponent,
    AdvisorsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
